if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						});
		  		}, 150)
				);
      }
    }
  );
}

/* Cart free-gift widget — handles claim click + auto-removal when cart drops below threshold */
if ( ! customElements.get('cart-free-gift') ) {

	class CartFreeGift extends HTMLElement {

		connectedCallback() {
			// Auto-remove the gift if the customer is no longer qualified.
			// (Liquid renders is-claimed without is-unlocked in that case.)
			if ( this.classList.contains('is-claimed') && ! this.classList.contains('is-unlocked') ) {
				this.removeGift();
				return;
			}

			const claimBtn = this.querySelector('[data-js-claim-free-gift]');
			if ( claimBtn ) {
				claimBtn.addEventListener('click', () => this.claimGift(claimBtn));
			}
		}

		claimGift(btn) {
			if ( this._claiming ) return;
			this._claiming = true;
			btn.classList.add('is-loading');
			btn.setAttribute('disabled', 'disabled');

			const variantId = parseInt(this.dataset.variantId, 10);
			const addUrl = (this.dataset.cartAddUrl || '/cart/add') + '.js';

			fetch(addUrl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
				body: JSON.stringify({ id: variantId, quantity: 1 })
			})
				.then(r => {
					if ( ! r.ok ) {
						return r.text().then(body => {
							const snippet = body ? body.slice(0, 160) : '';
							throw new Error(`Cart add failed: HTTP ${r.status}. ${snippet}`);
						});
					}
					return r.json();
				})
				.then(() => this._refreshCartUI())
				.catch(e => {
					console.error('Free gift claim failed:', e);
					btn.classList.remove('is-loading');
					btn.removeAttribute('disabled');
					this._claiming = false;
					this._showInlineError(e && e.message ? e.message : 'Could not add the free gift. Please try again.');
				});
		}

		_showInlineError(message) {
			let errorBox = this.querySelector('.cart-free-gift__error');
			if ( ! errorBox ) {
				errorBox = document.createElement('div');
				errorBox.className = 'cart-free-gift__error';
				errorBox.setAttribute('role', 'alert');
				const body = this.querySelector('.cart-free-gift__body');
				if ( body ) body.appendChild(errorBox);
			}
			errorBox.textContent = message;
		}

		removeGift() {
			const productId = this.dataset.productId;

			fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
				.then(r => r.json())
				.then(cart => {
					const giftItem = cart.items.find(item => String(item.product_id) === String(productId));
					if ( ! giftItem ) return null;
					return fetch('/cart/change.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
						body: JSON.stringify({ id: giftItem.key, quantity: 0 })
					});
				})
				.then(r => {
					if ( r ) return this._refreshCartUI();
				})
				.catch(e => console.error('Free gift auto-remove failed:', e));
		}

		_refreshCartUI() {
			return fetch('?section_id=helper-cart')
				.then(r => r.text())
				.then(text => {
					const doc = new DOMParser().parseFromString(text, 'text/html');
					const newForm = doc.getElementById('AjaxCartForm');
					const newSubtotal = doc.getElementById('AjaxCartSubtotal');
					const currentForm = document.getElementById('AjaxCartForm');
					const currentSubtotal = document.getElementById('AjaxCartSubtotal');

					if ( newForm && currentForm ) {
						currentForm.innerHTML = newForm.innerHTML;
						if ( typeof currentForm.ajaxifyCartItems === 'function' ) {
							currentForm.ajaxifyCartItems();
						}
					}
					if ( newSubtotal && currentSubtotal ) {
						currentSubtotal.innerHTML = newSubtotal.innerHTML;
					}

					const newCount = doc.querySelector('[data-cart-count]');
					const newTotal = doc.querySelector('[data-cart-total]');
					if ( newCount ) {
						document.querySelectorAll('[data-header-cart-count]').forEach(el => {
							el.textContent = newCount.textContent;
						});
					}
					if ( newTotal ) {
						document.querySelectorAll('[data-header-cart-total]').forEach(el => {
							el.textContent = newTotal.textContent;
						});
					}
				});
		}

	}

	customElements.define('cart-free-gift', CartFreeGift);

}